module.exports = __webpack_public_path__ + "img/Primeo_120X35.636a8439.png";